export default "__VITE_ASSET__73vApks3__"